<template>
    <div class="container-fluid">
        <validation-observer v-slot="{ validate }" slim>
            <form @submit.prevent="store(validate)">
                <offer-form :form="form" />
                <app-button :loading="loading" small>
                    {{ $t('Save') }}
                </app-button>
            </form>
        </validation-observer>
    </div>
</template>
<script>
import SpecialOfferService from '@services/specialOffer.service';
import OfferForm from './components/Form';
import {fixDate} from '@services/helper.service';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            form: {
                name: {
                    et: '',
                    en: ''
                },
                comments: {
                    et: '',
                    en: ''
                },
                start_date: null,
                end_date: null,
                discount_percent: 0,
                img: {},
                vehicles: []
            },
            loading: false
        };
    },
    watch: {
        locale() {
            this.resetFrom();
        }
    },
    computed: {
        ...mapGetters(['locale']),
    },
    methods: {
        resetFrom() {
            this.form = {
                start_date: fixDate(this.form.start_date),
                end_date: fixDate(this.form.end_date)
            };
        },
        store(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    SpecialOfferService.store(this.form).then(res => {
                        this.$toastr.s(this.$t('Saved'));
                        this.loading = true;
                        this.$router.push({ name: 'specialoffers' });
                    });
                }
            });
        }
    },
    components: {
        OfferForm
    }
};
</script>
